var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "page-transition" } }, [
    _c(
      "div",
      {
        staticClass: "hotel-page",
        class: {
          loading: _vm.loading,
          "loading-more-offers": _vm.loadingNextOffers,
          "loading-filters": _vm.loadingFilters
        }
      },
      [
        _c("result-hero"),
        _vm._v(" "),
        _c("result-area", {
          attrs: {
            "loading-offers": _vm.loading,
            "loading-filters": _vm.loadingFilters,
            "error-code": _vm.offerErrorCode,
            "filter-error": _vm.filterError
          },
          on: { loadmore: _vm.loadNextOffers }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42633e1c", { render: render, staticRenderFns: staticRenderFns })
  }
}